import React from 'react'
import './styles.scss'

const AvailableLabel = ({ badge, lightText }) => {
  if (!badge || badge === 'None') return null

  const labelColours = {
    'Available now': 'green',
    'Coming soon': 'grey', // default
    'Early access': 'white'
  }
  return (
    <div className={`available-label ${labelColours[badge]} ${lightText ? 'light' : ''}`}>
      <span className="available-label-text">{badge}</span>
    </div>
  )
}

export default AvailableLabel
